import * as Yup from 'yup';

export const adminLoginValidation = Yup.object().shape({
    username: Yup.string()
      .required('username is required'),
    password: Yup.string()
      .required('Password is required'),
  });
  